//walldata
// Switch to AWS S3-hosted images for Exclusive Hand Paintings

// Add multiple paintingSeries for different images
const paintingSeries = [
  "ABSTRACT (BLACK & WHITE)", // EHP 111
  "ABSTRACT (BLACK & WHITE)", // EHP 112
  "ABSTRACT (BLACK & WHITE)", // EHP 113
  "ABSTRACT (BLACK & WHITE)", // EHP 114
  "ABSTRACT (BLACK & WHITE)", // EHP 115
  "ABSTRACT (BLACK & WHITE)", // EHP 116
  "ABSTRACT (BLACK & WHITE)", // EHP 117
  "ABSTRACT (BLACK & WHITE)", // EHP 118
  "ABSTRACT (BLACK & WHITE)", // EHP 119
  "ABSTRACT (BLACK & WHITE)", // EHP 120
  "ABSTRACT (BLACK & WHITE)", // EHP 121
  "ABSTRACT (BLACK & WHITE)", // EHP 122
  "ABSTRACT (FLOW OF INSTINCT)", // EHP 123
  "ABSTRACT (FLOW OF INSTINCT)", // EHP 124
  "ABSTRACT (FLOW OF INSTINCT)", // EHP 125
  "ABSTRACT (FLOW OF INSTINCT)", // EHP 126
  "ABSTRACT (FLOW OF INSTINCT)", // EHP 127
  "ABSTRACT (FLOW OF INSTINCT)", // EHP 128
  "ABSTRACT (FLOW OF INSTINCT)", // EHP 129
  "ABSTRACT (FLOW OF INSTINCT)", // EHP 130 (⚠️ Looks wrong! Solved.)
  "ABSTRACT (FLOW OF INSTINCT)", // EHP 131
  "ABSTRACT (FLOW OF INSTINCT)", // EHP 132
  "ABSTRACT (FLOW OF INSTINCT)", // EHP 133
  "ABSTRACT (FLOW OF INSTINCT)", // EHP 134
  "ABSTRACT (FLOW OF INSTINCT)", // EHP 135
  "ABSTRACT (FLOW OF INSTINCT)", // EHP 136
  "ABSTRACT (FLOW OF INSTINCT)", // EHP 137
  "ABSTRACT (FLOW OF INSTINCT)", // EHP 138
  "ABSTRACT (FLOW OF INSTINCT)", // EHP 139
  "ABSTRACT (FLOW OF INSTINCT)", // EHP 140
  "ABSTRACT (FLOW OF INSTINCT)", // EHP 141
  "ABSTRACT (FLOW OF INSTINCT)", // EHP 142
  "ABSTRACT (FLOW OF INSTINCT)", // EHP 143
  "ABSTRACT (FLOW OF INSTINCT)", // EHP 144
  "ABSTRACT (FLOW OF INSTINCT)", // EHP 145
  "ABSTRACT (FLOW OF INSTINCT)", // EHP 146
  "ABSTRACT (FLOW OF INSTINCT)", // EHP 147
  "ABSTRACT (FLOW OF INSTINCT)", // EHP 148
  "ABSTRACT (FLOW OF INSTINCT)", // EHP 149
  "ABSTRACT (FLOW OF INSTINCT)", // EHP 150
  "ABSTRACT (FLOW OF INSTINCT)", // EHP 151
  "ABSTRACT (FLOW OF INSTINCT)", // EHP 152
  "ABSTRACT (FLOW OF INSTINCT)", // EHP 153
  "ABSTRACT (FLOW OF INSTINCT)", // EHP 154
  "ABSTRACT (FLOW OF INSTINCT)", // EHP 155
  "ABSTRACT (FLOW OF INSTINCT)", // EHP 156
  "ABSTRACT (FLOW OF INSTINCT)", // EHP 157
  "ABSTRACT (FLOW OF INSTINCT)", // EHP 158
  "ABSTRACT (FLOW OF INSTINCT)", // EHP 159
  "ABSTRACT (FLOW OF INSTINCT)", // EHP 160
  "ABSTRACT (FLOW OF INSTINCT)", // EHP 161
  "ABSTRACT (FLOW OF INSTINCT)", // EHP 162
  "ABSTRACT (FLOW OF INSTINCT)", // EHP 163
  "ABSTRACT (FLOW OF INSTINCT)", // EHP 164
  "ABSTRACT (FLOW OF INSTINCT)", // EHP 165
  "ABSTRACT (FLOW OF INSTINCT)", // EHP 166
  "ABSTRACT (FLOW OF INSTINCT)", // EHP 167
  "ABSTRACT (FLOW OF INSTINCT)", // EHP 168
  "ABSTRACT (FLOW OF INSTINCT)", // EHP 169
  "ABSTRACT (VIVACITY IN LAYERS)", // EHP 170
  "ABSTRACT (VIVACITY IN LAYERS)", // EHP 171
  "ABSTRACT (VIVACITY IN LAYERS)", // EHP 172
  "ABSTRACT (VIVACITY IN LAYERS)", // EHP 173
  "ABSTRACT (VIVACITY IN LAYERS)", // EHP 174
  "ABSTRACT (VIVACITY IN LAYERS)", // EHP 175
  "ABSTRACT (VIVACITY IN LAYERS)", // EHP 176
  "ABSTRACT (VIVACITY IN LAYERS)", // EHP 177
  "ABSTRACT (VIVACITY IN LAYERS)", // EHP 178
  "ABSTRACT (VIVACITY IN LAYERS)", // EHP 179
  "ABSTRACT (VIVACITY IN LAYERS)", // EHP 180
  "ABSTRACT (VIVACITY IN LAYERS)", // EHP 181
  "ABSTRACT (VIVACITY IN LAYERS)", // EHP 182
  "ABSTRACT (VIVACITY IN LAYERS)", // EHP 183
  "ABSTRACT (VIVACITY IN LAYERS)", // EHP 184
  "ABSTRACT (VIVACITY IN LAYERS)", // EHP 185
  "ABSTRACT (VIVACITY IN LAYERS)", // EHP 186
  "ABSTRACT (VIVACITY IN LAYERS)", // EHP 187
  "ABSTRACT (VIVACITY IN LAYERS)", // EHP 188
  "ABSTRACT (VIVACITY IN LAYERS)", // EHP 189
  "ABSTRACT (VIVACITY IN LAYERS)", // EHP 190
  "ABSTRACT (VIVACITY IN LAYERS)", // EHP 191
  "ABSTRACT (VIVACITY IN LAYERS)", // EHP 192
  "ABSTRACT (VIVACITY IN LAYERS)", // EHP 193
  "ABSTRACT (VIVACITY IN LAYERS)", // EHP 194
  "ABSTRACT (VIVACITY IN LAYERS)", // EHP 195
  "ABSTRACT (VIVACITY IN LAYERS)", // EHP 196
  "ABSTRACT (VIVACITY IN LAYERS)", // EHP 197
  "ABSTRACT (VIVACITY IN LAYERS)", // EHP 198
  "ABSTRACT (VIVACITY IN LAYERS)", // EHP 199
  "ABSTRACT (VIVACITY IN LAYERS)", // EHP 200
  "ABSTRACT (VIVACITY IN LAYERS)", // EHP 201
  "ABSTRACT (VIVACITY IN LAYERS)", // EHP 202
  "ABSTRACT (VIVACITY IN LAYERS)", // EHP 203
  "ABSTRACT (VIVACITY IN LAYERS)", // EHP 204
  "ABSTRACT (VIVACITY IN LAYERS)", // EHP 205
  "ABSTRACT (VIVACITY IN LAYERS)", // EHP 206
  "ABSTRACT (VIVACITY IN LAYERS)", // EHP 207
  "ABSTRACT (VIVACITY IN LAYERS)", // EHP 208
  "ABSTRACT (VIVACITY IN LAYERS)", // EHP 209
  "ABSTRACT (VIVACITY IN LAYERS)", // EHP 210
  "MOTHER & CHILD", // EHP 211
  "MOTHER & CHILD", // EHP 212
  "MOTHER & CHILD", // EHP 213
  "KRISHNA", // EHP 214
  "KRISHNA", // EHP 215
  "KRISHNA", // EHP 216
  "ABSTRACT (VIVACITY IN LAYERS)", // EHP 217
  "ABSTRACT (VIVACITY IN LAYERS)", // EHP 218
  "ABSTRACT (VIVACITY IN LAYERS)", // EHP 219
  "KRISHNA", // EHP 220
  "KRISHNA", // EHP 221
  "KRISHNA", // EHP 222
  "ABSTRACT (VIVACITY IN LAYERS)", // EHP 223
  "ABSTRACT (VIVACITY IN LAYERS)", // EHP 224
  "ABSTRACT (VIVACITY IN LAYERS)", // EHP 225
  "KRISHNA", // EHP 226
  "KRISHNA (JANMASHTAMI)", // EHP 227
  "KRISHNA (JANMASHTAMI)", // EHP 228
  "----", // EHP 229
  "----", // EHP 230
  "----", // EHP 231
  "ABSTRACT (VIVACITY IN LAYERS)", // EHP 232
  "ABSTRACT (VIVACITY IN LAYERS)", // EHP 233
  "ABSTRACT (VIVACITY IN LAYERS)", // EHP 234
  "KRISHNA", // EHP 235
  "KRISHNA", // EHP 236
  "KRISHNA", // EHP 237
  "MOTHER & CHILD", // EHP 238
  "MOTHER & CHILD", // EHP 239
  "MOTHER & CHILD", // EHP 240
  "KRISHNA", // EHP 241
  "KRISHNA", // EHP 242
  "KRISHNA", // EHP 243
  "ABSTRACT (VIVACITY IN LAYERS)", // EHP 244
  "ABSTRACT (VIVACITY IN LAYERS)", // EHP 245
  "ABSTRACT (VIVACITY IN LAYERS)", // EHP 246
  "KRISHNA", // EHP 247
  "KRISHNA", // EHP 248
  "KRISHNA", // EHP 249
  "MOTHER & CHILD", // EHP 250
  "MOTHER & CHILD", // EHP 251
  "MOTHER & CHILD", // EHP 252
  "ABSTRACT (VIVACITY IN LAYERS)", // EHP 253
  "ABSTRACT (VIVACITY IN LAYERS)", // EHP 254
  "ABSTRACT (FLOW OF INSTINCT)", // EHP 255
  "KRISHNA", // EHP 256
  "KRISHNA", // EHP 257
  "KRISHNA", // EHP 258
  "ABSTRACT (VIVACITY IN LAYERS)", // EHP 259
  "ABSTRACT (VIVACITY IN LAYERS)", // EHP 260
  "ABSTRACT (VIVACITY IN LAYERS)", // EHP 261
  "KRISHNA", // EHP 262
  "MOTHER & CHILD", // EHP 263
  "MOTHER & CHILD", // EHP 264
  "ABSTRACT", // EHP 265
  "ABSTRACT", // EHP 266
  "ABSTRACT", // EHP 267
  "KRISHNA", // EHP 268
  "KRISHNA", // EHP 269
  "KRISHNA", // EHP 270
  "ABSTRACT", // EHP 271
  "ABSTRACT", // EHP 272
  "ABSTRACT", // EHP 273
  "----", // EHP 274
  "----", // EHP 275
  "----", // EHP 276
  "KRISHNA", // EHP 277
  "KRISHNA", // EHP 278
  "KRISHNA", // EHP 279
  "ABSTRACT", // EHP 280
  "ABSTRACT", // EHP 281
  "ABSTRACT", // EHP 282
  "KRISHNA", // EHP 283
  "KRISHNA", // EHP 284
  "KRISHNA", // EHP 285
  "ABSTRACT", // EHP 286
  "ABSTRACT", // EHP 287
  "ABSTRACT", // EHP 288
  "KRISHNA", // EHP 289
  "KRISHNA", // EHP 290
  "KRISHNA", // EHP 291
  "ABSTRACT", // EHP 292
  "ABSTRACT (VIVACITY IN LAYERS)", // EHP 293
  "Pichwai", // EHP 294
  "Pichwai", // EHP 295
  "KRISHNA", // EHP 296
  "KRISHNA", // EHP 297
  "KRISHNA", // EHP 298
];




const paintingArtist = [
  "Romesh Mistry", // EHP 111
  "Romesh Mistry", // EHP 112
  "Romesh Mistry", // EHP 113
  "Romesh Mistry", // EHP 114
  "Romesh Mistry", // EHP 115
  "Romesh Mistry", // EHP 116
  "Romesh Mistry", // EHP 117
  "Romesh Mistry", // EHP 118
  "Romesh Mistry", // EHP 119
  "Romesh Mistry", // EHP 120
  "Romesh Mistry", // EHP 121
  "Romesh Mistry", // EHP 122
  "Romesh Mistry", // EHP 123
  "Romesh Mistry", // EHP 124
  "Romesh Mistry", // EHP 125
  "Romesh Mistry", // EHP 126
  "Romesh Mistry", // EHP 127
  "Romesh Mistry", // EHP 128
  "Romesh Mistry", // EHP 129
  "Romesh Mistry", // EHP 130
  "Romesh Mistry", // EHP 131
  "Romesh Mistry", // EHP 132
  "Romesh Mistry", // EHP 133
  "Romesh Mistry", // EHP 134
  "Romesh Mistry", // EHP 135
  "Romesh Mistry", // EHP 136
  "Romesh Mistry", // EHP 137
  "Romesh Mistry", // EHP 138
  "Romesh Mistry", // EHP 139
  "Romesh Mistry", // EHP 140
  "Romesh Mistry", // EHP 141
  "Romesh Mistry", // EHP 142
  "Romesh Mistry", // EHP 143
  "Romesh Mistry", // EHP 144
  "Romesh Mistry", // EHP 145
  "Romesh Mistry", // EHP 146
  "Romesh Mistry", // EHP 147
  "Romesh Mistry", // EHP 148
  "Romesh Mistry", // EHP 149
  "Romesh Mistry", // EHP 150
  "Romesh Mistry", // EHP 151
  "Romesh Mistry", // EHP 152
  "Romesh Mistry", // EHP 153
  "Romesh Mistry", // EHP 154
  "Romesh Mistry", // EHP 155
  "Romesh Mistry", // EHP 156
  "Romesh Mistry", // EHP 157
  "Romesh Mistry", // EHP 158
  "Romesh Mistry", // EHP 159
  "Romesh Mistry", // EHP 160
  "Romesh Mistry", // EHP 161
  "Romesh Mistry", // EHP 162
  "Romesh Mistry", // EHP 163
  "Romesh Mistry", // EHP 164
  "Romesh Mistry", // EHP 165
  "Romesh Mistry", // EHP 166
  "Romesh Mistry", // EHP 167
  "Romesh Mistry", // EHP 168
  "Romesh Mistry", // EHP 169
  "Romesh Mistry", // EHP 170
  "Romesh Mistry", // EHP 171
  "Romesh Mistry", // EHP 172
  "Romesh Mistry", // EHP 173
  "Romesh Mistry", // EHP 174
  "Romesh Mistry", // EHP 175
  "Romesh Mistry", // EHP 176
  "Romesh Mistry", // EHP 177
  "Romesh Mistry", // EHP 178
  "Romesh Mistry", // EHP 179
  "Romesh Mistry", // EHP 180
  "Romesh Mistry", // EHP 181
  "Romesh Mistry", // EHP 182
  "Romesh Mistry", // EHP 183
  "Romesh Mistry", // EHP 184
  "Romesh Mistry", // EHP 185
  "Romesh Mistry", // EHP 186
  "Romesh Mistry", // EHP 187
  "Romesh Mistry", // EHP 188
  "Romesh Mistry", // EHP 189
  "Romesh Mistry", // EHP 190
  "Romesh Mistry", // EHP 191
  "Romesh Mistry", // EHP 192
  "Romesh Mistry", // EHP 193
  "Romesh Mistry", // EHP 194
  "Romesh Mistry", // EHP 195
  "Romesh Mistry", // EHP 196
  "Romesh Mistry", // EHP 197
  "Romesh Mistry", // EHP 198
  "Romesh Mistry", // EHP 199
  "Romesh Mistry", // EHP 200
  "Romesh Mistry", // EHP 201
  "Romesh Mistry", // EHP 202
  "Romesh Mistry", // EHP 203
  "Romesh Mistry", // EHP 204
  "Romesh Mistry", // EHP 205
  "Romesh Mistry", // EHP 206
  "Romesh Mistry", // EHP 207
  "Romesh Mistry", // EHP 208
  "Romesh Mistry", // EHP 209
  "Romesh Mistry", // EHP 210
  "Romesh Mistry", // EHP 211
  "Romesh Mistry", // EHP 212
  "Romesh Mistry", // EHP 213
  "Romesh Mistry", // EHP 214
  "Romesh Mistry", // EHP 215
  "Romesh Mistry", // EHP 216
  "Romesh Mistry", // EHP 217
  "Romesh Mistry", // EHP 218
  "Romesh Mistry", // EHP 219
  "Romesh Mistry", // EHP 220
  "Romesh Mistry", // EHP 221
  "Romesh Mistry", // EHP 222
  "Romesh Mistry", // EHP 223
  "Romesh Mistry", // EHP 224
  "Romesh Mistry", // EHP 225
  "Romesh Mistry", // EHP 226
  "Romesh Mistry", // EHP 227
  "Romesh Mistry", // EHP 228
  "----", // EHP 229
  "----", // EHP 230
  "----", // EHP 231
  "Romesh Mistry", // EHP 232
  "Romesh Mistry", // EHP 233
  "Romesh Mistry", // EHP 234
  "Romesh Mistry", // EHP 235
  "Romesh Mistry", // EHP 236
  "Romesh Mistry", // EHP 237
  "Romesh Mistry", // EHP 238
  "Romesh Mistry", // EHP 239
  "Romesh Mistry", // EHP 240
  "Romesh Mistry", // EHP 241
  "Romesh Mistry", // EHP 242
  "Romesh Mistry", // EHP 243
  "Romesh Mistry", // EHP 244
  "Romesh Mistry", // EHP 245
  "Romesh Mistry", // EHP 246
  "Romesh Mistry", // EHP 247
  "Romesh Mistry", // EHP 248
  "Romesh Mistry", // EHP 249
  "Romesh Mistry", // EHP 250
  "Romesh Mistry", // EHP 251
  "Romesh Mistry", // EHP 252
  "Romesh Mistry", // EHP 253
  "Romesh Mistry", // EHP 254
  "Romesh Mistry", // EHP 255
  "Romesh Mistry", // EHP 256
  "Romesh Mistry", // EHP 257
  "Romesh Mistry", // EHP 258
  "Romesh Mistry", // EHP 259
  "Romesh Mistry", // EHP 260
  "Romesh Mistry", // EHP 261
  "Romesh Mistry", // EHP 262
  "Romesh Mistry", // EHP 263
  "Romesh Mistry", // EHP 264
  "Romesh Mistry", // EHP 265
  "Romesh Mistry", // EHP 266
  "Romesh Mistry", // EHP 267
  "Romesh Mistry", // EHP 268
  "Romesh Mistry", // EHP 269
  "Romesh Mistry", // EHP 270
  "Romesh Mistry", // EHP 271
  "Romesh Mistry", // EHP 272
  "Romesh Mistry", // EHP 273
  "----", // EHP 274
  "----", // EHP 275
  "----", // EHP 276
  "Romesh Mistry", // EHP 277
  "Romesh Mistry", // EHP 278
  "Romesh Mistry", // EHP 279
  "Romesh Mistry", // EHP 280
  "Romesh Mistry", // EHP 281
  "Romesh Mistry", // EHP 282
  "Romesh Mistry", // EHP 283
  "Romesh Mistry", // EHP 284
  "Romesh Mistry", // EHP 285
  "Romesh Mistry", // EHP 286
  "Romesh Mistry", // EHP 287
  "Romesh Mistry", // EHP 288
  "Romesh Mistry", // EHP 289
  "Romesh Mistry", // EHP 290
  "Romesh Mistry", // EHP 291
  "Romesh Mistry", // EHP 292
  "Romesh Mistry", // EHP 293
  "Zeel Mistry", // EHP 294
  "Zeel Mistry", // EHP 295
  "Romesh Mistry", // EHP 296
  "Romesh Mistry", // EHP 297
  "Romesh Mistry", // EHP 298
];



const paintingMedium = [
  "Acrylic on Canvas", // EHP 111
  "Acrylic on Canvas", // EHP 112
  "Acrylic on Canvas", // EHP 113
  "Acrylic on Canvas", // EHP 114
  "Acrylic on Canvas", // EHP 115
  "Acrylic on Canvas", // EHP 116
  "Acrylic on Canvas", // EHP 117
  "Acrylic on Canvas", // EHP 118
  "Acrylic on Canvas", // EHP 119
  "Acrylic on Canvas", // EHP 120
  "Acrylic on Canvas", // EHP 121
  "Acrylic on Canvas", // EHP 122
  "Acrylic on Canvas", // EHP 123
  "Acrylic on Canvas", // EHP 124
  "Acrylic on Canvas", // EHP 125
  "Acrylic on Canvas", // EHP 126
  "Acrylic on Canvas", // EHP 127
  "Acrylic on Canvas", // EHP 128
  "Acrylic on Canvas", // EHP 129
  "Acrylic on Canvas", // EHP 130
  "Acrylic on Canvas", // EHP 131
  "Acrylic on Canvas", // EHP 132
  "Acrylic on Canvas", // EHP 133
  "Acrylic on Canvas", // EHP 134
  "Acrylic on Canvas", // EHP 135
  "Acrylic on Canvas", // EHP 136
  "Acrylic on Canvas", // EHP 137
  "Acrylic on Canvas", // EHP 138
  "Acrylic on Canvas", // EHP 139
  "Acrylic on Canvas", // EHP 140
  "Acrylic on Canvas", // EHP 141
  "Acrylic on Canvas", // EHP 142
  "Acrylic on Canvas", // EHP 143
  "Acrylic on Canvas", // EHP 144
  "Acrylic on Canvas", // EHP 145
  "Acrylic on Canvas", // EHP 146
  "Acrylic on Canvas", // EHP 147
  "Acrylic on Canvas", // EHP 148
  "Acrylic on Canvas", // EHP 149
  "Acrylic on Canvas", // EHP 150
  "Acrylic on Canvas", // EHP 151
  "Acrylic on Canvas", // EHP 152
  "Acrylic on Canvas", // EHP 153
  "Acrylic on Canvas", // EHP 154
  "Acrylic on Canvas", // EHP 155
  "Acrylic on Canvas", // EHP 156
  "Acrylic on Canvas", // EHP 157
  "Acrylic on Canvas", // EHP 158
  "Acrylic on Canvas", // EHP 159
  "Acrylic on Canvas", // EHP 160
  "Acrylic on Canvas", // EHP 161
  "Acrylic on Canvas", // EHP 162
  "Acrylic on Canvas", // EHP 163
  "Acrylic on Canvas", // EHP 164
  "Acrylic on Canvas", // EHP 165
  "Acrylic on Canvas", // EHP 166
  "Acrylic on Canvas", // EHP 167
  "Acrylic on Canvas", // EHP 168
  "Acrylic on Canvas", // EHP 169
  "Acrylic on Canvas", // EHP 170
  "Acrylic on Canvas", // EHP 171
  "Acrylic on Canvas", // EHP 172
  "Acrylic on Canvas", // EHP 173
  "Acrylic on Canvas", // EHP 174
  "Acrylic on Canvas", // EHP 175
  "Acrylic on Canvas", // EHP 176
  "Acrylic on Canvas", // EHP 177
  "Acrylic on Canvas", // EHP 178
  "Acrylic on Canvas", // EHP 179
  "Acrylic on Canvas", // EHP 180
  "Acrylic on Canvas", // EHP 181
  "Acrylic on Canvas", // EHP 182
  "Acrylic on Canvas", // EHP 183
  "Acrylic on Canvas", // EHP 184
  "Acrylic on Canvas", // EHP 185
  "Acrylic on Canvas", // EHP 186
  "Acrylic on Canvas", // EHP 187
  "Acrylic & Ink on Canvas", // EHP 188
  "Acrylic on Canvas", // EHP 189
  "Acrylic on Canvas", // EHP 190
  "Acrylic on Canvas", // EHP 191
  "Acrylic on Canvas", // EHP 192
  "Acrylic on Canvas", // EHP 193
  "Acrylic on Canvas", // EHP 194
  "Acrylic on Canvas", // EHP 195
  "Acrylic on Canvas", // EHP 196
  "Acrylic on Canvas", // EHP 197
  "Acrylic on Canvas", // EHP 198
  "Acrylic on Canvas", // EHP 199
  "Acrylic on Canvas", // EHP 200
  "Acrylic on Canvas", // EHP 201
  "Acrylic on Canvas", // EHP 202
  "Acrylic on Canvas", // EHP 203
  "Acrylic on Canvas", // EHP 204
  "Acrylic on Canvas", // EHP 205
  "Acrylic on Canvas", // EHP 206
  "Acrylic on Canvas", // EHP 207
  "Acrylic on Canvas", // EHP 208
  "Acrylic on Canvas", // EHP 209
  "Acrylic on Canvas", // EHP 210
  "Oil on Paper", // EHP 211
  "Acrylic on Canvas", // EHP 212
  "Acrylic on Canvas", // EHP 213
  "Acrylic on Canvas", // EHP 214
  "Acrylic on Canvas", // EHP 215
  "Acrylic on Canvas", // EHP 216
  "Acrylic on Canvas", // EHP 217
  "Acrylic on Canvas", // EHP 218
  "Acrylic on Canvas", // EHP 219
  "Acrylic on Canvas", // EHP 220
  "Acrylic on Canvas", // EHP 221
  "Acrylic on Canvas", // EHP 222
  "Acrylic on Canvas", // EHP 223
  "Acrylic on Canvas", // EHP 224
  "Acrylic on Canvas", // EHP 225
  "Acrylic on Canvas", // EHP 226
  "Mix Media on Canvas", // EHP 227
  "Acrylic on Canvas", // EHP 228
  "----", // EHP 229
  "----", // EHP 230
  "----", // EHP 231
  "Acrylic on Canvas", // EHP 232
  "Acrylic on Canvas", // EHP 233
  "Acrylic on Canvas", // EHP 234
  "Acrylic on Canvas", // EHP 235
  "Acrylic on Canvas", // EHP 236
  "Acrylic on Canvas", // EHP 237
  "Acrylic on Paper", // EHP 238
  "Acrylic on Paper", // EHP 239
  "Acrylic on Paper", // EHP 240
  "Acrylic on Canvas", // EHP 241
  "Acrylic on Canvas", // EHP 242
  "Acrylic on Canvas", // EHP 243
  "Acrylic on Canvas", // EHP 244
  "Acrylic on Canvas", // EHP 245
  "Acrylic on Canvas", // EHP 246
  "Acrylic on Canvas", // EHP 247
  "Acrylic on Canvas", // EHP 248
  "Acrylic on Canvas", // EHP 249
  "Acrylic on Canvas", // EHP 250
  "Acrylic on Canvas", // EHP 251
  "Acrylic on Canvas", // EHP 252
  "Acrylic on Canvas", // EHP 253
  "Acrylic on Canvas", // EHP 254
  "Acrylic on Canvas", // EHP 255
  "Acrylic on Canvas", // EHP 256
  "Acrylic on Canvas", // EHP 257
  "Acrylic on Canvas", // EHP 258
  "Acrylic on Canvas", // EHP 259
  "Acrylic on Canvas", // EHP 260
  "Acrylic on Canvas", // EHP 261
  "Acrylic on Canvas", // EHP 262
  "Acrylic on Canvas", // EHP 263
  "Acrylic on Canvas", // EHP 264
  "Acrylic on Canvas", // EHP 265
  "Acrylic on Canvas", // EHP 266
  "Acrylic on Canvas", // EHP 267
  "Acrylic on Canvas", // EHP 268
  "Acrylic on Canvas", // EHP 269
  "Acrylic on Canvas", // EHP 270
  "Acrylic on Canvas", // EHP 271
  "Acrylic on Canvas", // EHP 272
  "Acrylic on Canvas", // EHP 273
  "----", // EHP 274
  "----", // EHP 275
  "----", // EHP 276
  "Acrylic on Canvas", // EHP 277
  "Acrylic on Canvas", // EHP 278
  "Acrylic on Canvas", // EHP 279
  "Acrylic on Canvas", // EHP 280
  "Acrylic on Canvas", // EHP 281
  "Acrylic on Canvas", // EHP 282
  "Acrylic on Canvas", // EHP 283
  "Acrylic on Canvas", // EHP 284
  "Acrylic on Canvas", // EHP 285
  "Acrylic on Canvas", // EHP 286
  "Acrylic on Canvas", // EHP 287
  "Acrylic on Canvas", // EHP 288
  "Acrylic on Canvas", // EHP 289
  "Acrylic on Canvas", // EHP 290
  "Acrylic on Canvas", // EHP 291
  "Acrylic on Canvas", // EHP 292
  "Acrylic on Canvas", // EHP 293
  "Acrylic on Canvas", // EHP 294
  "Acrylic on Canvas", // EHP 295
  "Acrylic on Canvas", // EHP 296
  "Acrylic on Canvas", // EHP 297
  "Acrylic on Canvas", // EHP 298
];




const paintingSize = [
  "19 x 35 Inches", // EHP 111
  "16 x 35 Inches", // EHP 112
  "19 x 35 Inches", // EHP 113
  "16 x 30 Inches", // EHP 114
  "26 x 35 Inches", // EHP 115
  "20 x 20 Inches", // EHP 116
  "20 x 20 Inches", // EHP 117
  "20 x 20 Inches", // EHP 118
  "20 x 20 Inches", // EHP 119
  "20 x 20 Inches", // EHP 120
  "28 x 28 Inches", // EHP 121
  "20 x 36 Inches", // EHP 122
  "52 x 36 Inches", // EHP 123
  "32 x 39 Inches", // EHP 124
  "30 x 39 Inches", // EHP 125
  "39 x 39 Inches", // EHP 126
  "29 x 35 Inches", // EHP 127
  "29 x 29 Inches", // EHP 128
  "32 x 39 Inches", // EHP 129
  "41 x 23 Inches", // EHP 130 (⚠️ this one was a mistake under "Series", but size is given)
  "41 x 32 Inches", // EHP 131
  "29 x 29 Inches", // EHP 132
  "39 x 32 Inches", // EHP 133
  "20 x 30 Inches", // EHP 134
  "24 x 24 Inches", // EHP 135
  "31 x 36 Inches", // EHP 136
  "25 x 35 Inches", // EHP 137
  "38 x 25 Inches", // EHP 138
  "27 x 41 Inches", // EHP 139
  "32 x 32 Inches", // EHP 140
  "19 x 27 Inches", // EHP 141
  "60 x 38 Inches", // EHP 142
  "35 x 35 Inches", // EHP 143
  "46 x 34 Inches", // EHP 144
  "16 x 35 Inches", // EHP 145
  "30 x 36 Inches", // EHP 146
  "20 x 29 Inches", // EHP 147
  "24 x 24 Inches", // EHP 148
  "24 x 24 Inches", // EHP 149
  "32 x 32 Inches", // EHP 150
  "32 x 20 Inches", // EHP 151
  "LL X WW Inches", // EHP 152
  "LL X WW Inches", // EHP 153
  "LL X WW Inches", // EHP 154
  "LL X WW Inches", // EHP 155
  "LL X WW Inches", // EHP 156
  "LL X WW Inches", // EHP 157
  "17 x 15 Inches each (Set of 2)", // EHP 158
  "6 x 6 Inches (Set of 4)", // EHP 159
  "6 x 6 Inches (Set of 4)", // EHP 160
  "25 x 40 Inches", // EHP 161
  "21 x 25 Inches", // EHP 162
  "24 x 36 Inches", // EHP 163
  "30 x 30 Inches", // EHP 164
  "26 x 35 Inches", // EHP 165
  "38 x 38 Inches", // EHP 166
  "17 x 17 Inches", // EHP 167
  "17 x 17 Inches", // EHP 168
  "17 x 17 Inches", // EHP 169
  "24 x 24 Inches", // EHP 170
  "20 x 20 Inches", // EHP 171
  "24 x 24 Inches", // EHP 172
  "24 x 24 Inches", // EHP 173
  "24 x 24 Inches", // EHP 174
  "30 x 30 Inches", // EHP 175
  "30 x 30 Inches", // EHP 176
  "24 x 24 Inches", // EHP 177
  "26 x 35 Inches", // EHP 178
  "33 x 25 Inches", // EHP 179
  "32 x 43 Inches", // EHP 180
  "22 x 22 Inches", // EHP 181
  "19 x 19 Inches", // EHP 182
  "19 x 19 Inches", // EHP 183
  "19 x 19 Inches", // EHP 184
  "19 x 19 Inches", // EHP 185
  "31 x 42 Inches", // EHP 186
  "28 x 28 Inches", // EHP 187
  "21 x 43 Inches", // EHP 188
  "LL x WW Inches", // EHP 189
  "LL x WW Inches", // EHP 190
  "29 x 31 Inches", // EHP 191
  "16 x 17 Inches", // EHP 192
  "16 x 33 Inches", // EHP 193
  "29 x 31 Inches", // EHP 194
  "20 x 20 Inches", // EHP 195
  "21 x 21 Inches", // EHP 196
  "23 x 35 Inches", // EHP 197
  "22 x 35 Inches", // EHP 198
  "22 x 33 Inches", // EHP 199
  "19 x 19 Inches", // EHP 200
  "19 x 19 Inches", // EHP 201
  "13 x 17 Inches", // EHP 202
  "19 x 25 Inches", // EHP 203
  "23 x 23 Inches", // EHP 204
  "15 x 34 Inches", // EHP 205
  "12 x 29 Inches", // EHP 206
  "12 x 29 Inches each (Set of 2)", // EHP 207
  "12 x 29 Inches each (Set of 2)", // EHP 208
  "12 x 29 Inches each (Set of 2)", // EHP 209
  "34 x 48 Inches", // EHP 210
  "26 x 35 Inches", // EHP 211
  "35 x 35 Inches", // EHP 212
  "35 x 35 Inches", // EHP 213
  "37 x 34 Inches", // EHP 214
  "19 x 21 Inches", // EHP 215
  "26 x 35 Inches", // EHP 216
  "33 x 34 Inches", // EHP 217
  "33 x 33 Inches", // EHP 218
  "33 x 34 Inches", // EHP 219
  "48 x 33 Inches", // EHP 220
  "28 x 33 Inches", // EHP 221
  "96 x 48 Inches", // EHP 222
  "23 x 46 Inches", // EHP 223
  "23 x 46 Inches", // EHP 224
  "27 x 36 Inches", // EHP 225
  "37 x 34 Inches", // EHP 226
  "29 x 21 Inches", // EHP 227
  "30 x 30 Inches", // EHP 228
  "----", // EHP 229 (Missing)
  "----", // EHP 230 (Missing)
  "----", // EHP 231 (Missing)
  "26 x 35 Inches", // EHP 232
  "24 x 34 Inches", // EHP 233
  "20 x 34 Inches", // EHP 234
  "33 x 52 Inches", // EHP 235
  "43 x 36 Inches", // EHP 236
  "32 x 36 Inches", // EHP 237
  "11 x 15 Inches", // EHP 238
  "11 x 15 Inches", // EHP 239
  "11 x 15 Inches", // EHP 240
  "36 x 28 Inches", // EHP 241
  "33 x 52 Inches", // EHP 242
  "14 x 21 Inches", // EHP 243
  "21 x 32 Inches", // EHP 244
  "27 x 37 Inches", // EHP 245
  "28 x 46 Inches", // EHP 246
  "33 x 52 Inches", // EHP 247
  "19 x 36 Inches", // EHP 248
  "24 x 28 Inches", // EHP 249
  "32 x 32 Inches", // EHP 250
  "21 x 14 Inches", // EHP 251
  "32 x 32 Inches", // EHP 252
  "30 x 39 Inches", // EHP 253
  "24 x 34 Inches", // EHP 254
  "47 x 32 Inches", // EHP 255
  "31 x 38 Inches", // EHP 256
  "31 x 31 Inches", // EHP 257
  "21 x 21 Inches", // EHP 258
  "28 x 30 Inches", // EHP 259
  "23 x 23 Inches", // EHP 260
  "23 x 23 Inches", // EHP 261
  "25 x 34 Inches", // EHP 262
  "21 x 21 Inches", // EHP 263
  "14 x 21 Inches", // EHP 264
  "28 x 28 Inches", // EHP 265
  "28 x 28 Inches", // EHP 266
  "28 x 28 Inches", // EHP 267
  "37 x 34 Inches", // EHP 268
  "27 x 36 Inches", // EHP 269
  "36 x 35 Inches", // EHP 270
  "28 x 28 Inches", // EHP 271
  "27 x 28 Inches", // EHP 272
  "28 x 28 Inches", // EHP 273
  "----", // EHP 274 (Missing)
  "----", // EHP 275 (Missing)
  "----", // EHP 276 (Missing)
  "20 x 25 Inches", // EHP 277
  "25 x 23 Inches", // EHP 278
  "17 x 28 Inches", // EHP 279
  "28 x 37 Inches", // EHP 280
  "28 x 23 Inches", // EHP 281
  "25 x 28 Inches", // EHP 282
  "22 x 36 Inches", // EHP 283
  "20 x 36 Inches", // EHP 284
  "36 x 27 Inches", // EHP 285
  "12 x 14 Inches", // EHP 286
  "12 x 14 Inches", // EHP 287
  "29 x 36 Inches", // EHP 288
  "31 x 28 Inches", // EHP 289
  "28 x 38 Inches", // EHP 290
  "24 x 24 Inches", // EHP 291
  "28 x 28 Inches", // EHP 292
  "39 x 21 Inches", // EHP 293
  "24 x 30 Inches", // EHP 294
  "24 x 30 Inches", // EHP 295
  "27 x 45 Inches", // EHP 296
  "27 x 45 Inches", // EHP 297
  "27 x 45 Inches", // EHP 298
];



const paintingPrice = [
  "34,000.00", // EHP 111
  "30,000.00", // EHP 112
  "34,000.00", // EHP 113
  "25,000.00", // EHP 114
  "43,000.00", // EHP 115
  "20,000.00", // EHP 116
  "20,000.00", // EHP 117
  "20,000.00", // EHP 118
  "20,000.00", // EHP 119
  "20,000.00", // EHP 120
  "38,000.00", // EHP 121
  "36,000.00", // EHP 122
  "94,000.00", // EHP 123
  "61,000.00", // EHP 124
  "63,000.00", // EHP 125
  "70,000.00", // EHP 126
  "50,000.00", // EHP 127
  "43,000.00", // EHP 128
  "63,000.00", // EHP 129
  "61,000.00", // EHP 130
  "63,000.00", // EHP 131
  "43,000.00", // EHP 132
  "63,000.00", // EHP 133
  "34,000.00", // EHP 134
  "25,000.00", // EHP 135
  "55,000.00", // EHP 136
  "43,000.00", // EHP 137
  "47,000.00", // EHP 138
  "55,000.00", // EHP 139
  "52,000.00", // EHP 140
  "25,000.00", // EHP 141
  "97,000.00", // EHP 142
  "61,000.00", // EHP 143
  "60,000.00", // EHP 144
  "25,000.00", // EHP 145
  "55,000.00", // EHP 146
  "NOT FOR SALE", // EHP 147
  "SOLD", // EHP 148
  "SOLD", // EHP 149
  "SOLD", // EHP 150
  "SOLD", // EHP 151
  "-------.00", // EHP 152
  "-------.00", // EHP 153
  "-------.00", // EHP 154
  "-------.00", // EHP 155
  "-------.00", // EHP 156
  "-------.00", // EHP 157
  "16,000.00", // EHP 158
  "20,000.00", // EHP 159
  "SOLD", // EHP 160
  "50,000.00", // EHP 161
  "22,000.00", // EHP 162
  "43,000.00", // EHP 163
  "45,000.00", // EHP 164
  "45,000.00", // EHP 165
  "70,000.00", // EHP 166
  "15,000.00", // EHP 167
  "15,000.00", // EHP 168
  "15,000.00", // EHP 169
  "25,000.00", // EHP 170
  "SOLD", // EHP 171
  "18,000.00", // EHP 172
  "SOLD", // EHP 173
  "SOLD", // EHP 174
  "40,000.00", // EHP 175
  "40,000.00", // EHP 176
  "20,000.00", // EHP 177
  "41,000.00", // EHP 178
  "37,000.00", // EHP 179
  "61,000.00", // EHP 180
  "22,000.00", // EHP 181
  "18,000.00", // EHP 182
  "18,000.00", // EHP 183
  "18,000.00", // EHP 184
  "18,000.00", // EHP 185
  "50,000.00", // EHP 186
  "34,000.00", // EHP 187
  "40,000.00", // EHP 188
  "------.00", // EHP 189
  "------.00", // EHP 190
  "45,000.00", // EHP 191
  "15,000.00", // EHP 192
  "25,000.00", // EHP 193
  "25,000.00", // EHP 194
  "20,000.00", // EHP 195
  "20,000.00", // EHP 196
  "34,000.00", // EHP 197
  "34,000.00", // EHP 198
  "34,000.00", // EHP 199
  "12,000.00", // EHP 200
  "12,000.00", // EHP 201
  "9,700.00", // EHP 202
  "22,000.00", // EHP 203
  "23,000.00", // EHP 204
  "23,000.00", // EHP 205
  "18,000.00", // EHP 206
  "30,000.00", // EHP 207
  "30,000.00", // EHP 208
  "30,000.00", // EHP 209
  "70,000.00", // EHP 210
  "30,000.00", // EHP 211
  "43,000.00", // EHP 212
  "43,000.00", // EHP 213
  "43,000.00", // EHP 214
  "16,000.00", // EHP 215
  "37,000.00", // EHP 216
  "70,000.00", // EHP 217
  "55,000.00", // EHP 218
  "70,000.00", // EHP 219
  "52,000.00", // EHP 220
  "33,000.00", // EHP 221
  "150,000.00", // EHP 222
  "70,000.00", // EHP 223
  "70,000.00", // EHP 224
  "68,000.00", // EHP 225
  "43,000.00", // EHP 226
  "23,000.00", // EHP 227
  "30,000.00", // EHP 228
  "----", // EHP 229
  "----", // EHP 230
  "----", // EHP 231
  "61,000.00", // EHP 232
  "57,000.00", // EHP 233
  "50,000.00", // EHP 234
  "61,000.00", // EHP 235
  "61,000.00", // EHP 236
  "43,000.00", // EHP 237
  "7,000.00", // EHP 238
  "7,000.00", // EHP 239
  "7,000.00", // EHP 240
  "30,000.00", // EHP 241
  "SOLD", // EHP 242
  "15,000.00", // EHP 243
  "45,000.00", // EHP 244
  "70,000.00", // EHP 245
  "70,000.00", // EHP 246
  "SOLD", // EHP 247
  "27,000.00", // EHP 248
  "27,000.00", // EHP 249
  "43,000.00", // EHP 250
  "10,000.00", // EHP 251
  "43,000.00", // EHP 252
  "70,000.00", // EHP 253
  "57,000.00", // EHP 254
  "70,000.00", // EHP 255
  "47,000.00", // EHP 256
  "38,000.00", // EHP 257
  "16,000.00", // EHP 258
  "43,000.00", // EHP 259
  "25,000.00", // EHP 260
  "25,000.00", // EHP 261
  "40,000.00", // EHP 262
  "16,000.00", // EHP 263
  "10,000.00", // EHP 264
  "30,000.00", // EHP 265
  "30,000.00", // EHP 266
  "30,000.00", // EHP 267
  "49,000.00", // EHP 268
  "38,000.00", // EHP 269
  "49,000.00", // EHP 270
  "30,000.00", // EHP 271
  "30,000.00", // EHP 272
  "30,000.00", // EHP 273
  "----", // EHP 274
  "----", // EHP 275
  "----", // EHP 276
  "20,000.00", // EHP 277
  "23,000.00", // EHP 278
  "20,000.00", // EHP 279
  "34,000.00", // EHP 280
  "25,000.00", // EHP 281
  "27,000.00", // EHP 282
  "33,000.00", // EHP 283
  "SOLD", // EHP 284
  "SOLD", // EHP 285
  "7,000.00", // EHP 286
  "7,000.00", // EHP 287
  "43,000.00", // EHP 288
  "34,000.00", // EHP 289
  "43,000.00", // EHP 290
  "25,000.00", // EHP 291
  "SOLD", // EHP 292
  "57,000.00", // EHP 293
  "32,000.00  ", // EHP 294
  "32,000.00  ", // EHP 295
  "61,000.00", // EHP 296
  "61,000.00", // EHP 297
  "61,000.00", // EHP 298
];



// A consistent shuffle function that produces a fixed, non-sequential order
const consistentShuffle = (array) => {
  const newArray = [...array];
  // Sort the array using a consistent but pseudo-random key
  return newArray.sort((a, b) => {
    // We can use a combination of properties or indices to create a fixed shuffle order
    // This example uses a basic, consistent formula to "shuffle" the items
    const aValue = a.code.charCodeAt(a.code.length - 1) * a.code.length;
    const bValue = b.code.charCodeAt(b.code.length - 1) * b.code.length;
    
    // You can adjust this to your liking for a different fixed shuffle
    return aValue - bValue;
  });
};

// Build S3 URLs by EHP code mapping
const S3_BASE_1 = 'https://vizaura.s3.eu-north-1.amazonaws.com/HandPainting/Exclusive+Hand+1';
const S3_BASE_2 = 'https://vizaura.s3.eu-north-1.amazonaws.com/HandPainting/Exclusive+Hand+2';

// Returns the S3 image URL for a given EHP code number
// Mapping:
// - EHP 111..209  -> Exclusive Hand 1 /(1)..(99).jpg
// - EHP 210..295  -> Exclusive Hand 2 /(100)..(185).jpg
// - EHP 296..298  -> Exclusive Hand 1 /1.jpg, /2.jpg, /3.jpg (no parentheses)
const getS3UrlForCode = (codeNumber) => {
  if (codeNumber >= 111 && codeNumber <= 209) {
    const imgNum = codeNumber - 110; // 111 -> 1 ... 209 -> 99
    return `${S3_BASE_1}/(${imgNum}).jpg`;
  }
  if (codeNumber >= 210 && codeNumber <= 295) {
    const imgNum = codeNumber - 110; // 210 -> 100 ... 295 -> 185
    return `${S3_BASE_2}/(${imgNum}).jpg`;
  }
  if (codeNumber === 296) return `${S3_BASE_1}/1.jpg`;
  if (codeNumber === 297) return `${S3_BASE_1}/2.jpg`;
  if (codeNumber === 298) return `${S3_BASE_1}/3.jpg`;
  return '';
};

// Build the complete dataset for EHP 111..298
const allWalldatas = Array.from({ length: 298 - 111 + 1 }, (_, idx) => {
  const codeNumber = 111 + idx;
  const codeLabel = `#EHP${String(codeNumber).padStart(3, '0')}`;
  return {
    Img: getS3UrlForCode(codeNumber),
    code: codeLabel,
    series: paintingSeries[idx] || "Default description",
    artist: paintingArtist[idx] || "Default context",
    size: paintingSize[idx] || "Default size",
    medium: paintingMedium[idx] || "Default medium",
    price: paintingPrice[idx] || "Default price",
    btn: 'View Detail',
  };
});

const firstImage = allWalldatas[0];
const remainingImages = allWalldatas.slice(1);

// Shuffle the rest of the images consistently.
const shuffledRemainingImages = consistentShuffle(remainingImages);

// Re-add the first image to the beginning of the shuffled array.
export const walldatas = [firstImage, ...shuffledRemainingImages];